export default {
  state: {
    document: {},
    documentsFilters: {},
  },

  getters: {
    getDocument: (state) => state.document,
    getDocumentsFilters: (state) => state.documentsFilters,
  },

  mutations: {
    setDocument(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.document = {
        id: isUpdate ? data.id : "",
        description: isUpdate ? data.description : "",
        code: isUpdate ? data.code : "",
      };
    },

    setDocumentsFilters(state, filters) {
      state.documentsFilters = filters;
    },
  },

  actions: {
    changeDocument(context, data) {
      context.commit("setDocument", data);
    },

    changeDocumentsFilters(context, filters) {
      context.commit("setDocumentsFilters", filters);
    },
  },
};
